// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --loading-spinner-color: var(--cv-primary, var(--color-primary, #5a3ec8));
}

.loading-spinner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #5a3ec8;
  color: var(--loading-spinner-color);
}

.loading-spinner__icon {
  width: 48px;
  height: 48px;
  animation: loading-spinner-rotate 1s linear infinite;
}

.loading-spinner__path {
  stroke: currentColor;
  stroke-width: 5;
  stroke-linecap: round;
  animation: loading-spinner-dash 1.5s ease-in-out infinite;
}

.loading-spinner__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
}

.loading-spinner--sm .loading-spinner__icon {
  width: 32px;
  height: 32px;
}

.loading-spinner--lg .loading-spinner__icon {
  width: 64px;
  height: 64px;
}

@keyframes loading-spinner-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-spinner-dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/LoadingSpinner.css"],"names":[],"mappings":"AAAA;EACE,yEAAyE;AAC3E;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF","sourcesContent":[":root {\n  --loading-spinner-color: var(--cv-primary, var(--color-primary, #5a3ec8));\n}\n\n.loading-spinner {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: var(--loading-spinner-color);\n}\n\n.loading-spinner__icon {\n  width: 48px;\n  height: 48px;\n  animation: loading-spinner-rotate 1s linear infinite;\n}\n\n.loading-spinner__path {\n  stroke: currentColor;\n  stroke-width: 5;\n  stroke-linecap: round;\n  animation: loading-spinner-dash 1.5s ease-in-out infinite;\n}\n\n.loading-spinner__label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.loading-spinner--sm .loading-spinner__icon {\n  width: 32px;\n  height: 32px;\n}\n\n.loading-spinner--lg .loading-spinner__icon {\n  width: 64px;\n  height: 64px;\n}\n\n@keyframes loading-spinner-rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loading-spinner-dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35;\n  }\n\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
